import { customScroll } from 'styles/variables';

export const DEFAULT_MENU_STYLES = {
    backgroundColor: 'var(--bg-primary)',
    border: 'solid 1px var(--border-secondary)',
    borderRadius: '8px',
    boxShadow: 'box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.05)',
    maxHeight: '260px',
    ...customScroll,
};

export const DEFAULT_MENU_ITEM_STYLES = {
    fontSize: '16px',
    padding: '4px 8px',
    color: 'var(--text-primary)',
    minWidth: '120px',
    height: '40px',
    '&:hover:not(input)': {
        background: 'var(--button-secondary-bg_hover)',
    },
};

export const DEFAULT_MENU_LIST_STYLES = { display: 'flex', flexDirection: 'column' };
